import { render, staticRenderFns } from "./clothSearch.vue?vue&type=template&id=6bcac6cb&scoped=true"
import script from "./clothSearch.vue?vue&type=script&lang=js"
export * from "./clothSearch.vue?vue&type=script&lang=js"
import style0 from "./clothSearch.vue?vue&type=style&index=0&id=6bcac6cb&prod&lang=scss&scoped=true"
import style1 from "./clothSearch.vue?vue&type=style&index=1&id=6bcac6cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcac6cb",
  null
  
)

export default component.exports